function generateNumFormat(noDecimal = false) {
    return new Intl.NumberFormat("en-IN", {
        // style: "currency",
        // currency: "INR",
        minimumFractionDigits: noDecimal ? 0 : 2,
        maximumFractionDigits: noDecimal ? 0 : 2
    });
}

let isNoDecimal = false;
let numberFormat = generateNumFormat(isNoDecimal);

export const formatCurrency = (num, noDecimal = true) => {
    if (isNoDecimal !== noDecimal) {
        isNoDecimal = noDecimal;
        numberFormat = generateNumFormat(noDecimal);
    }
    return num ? numberFormat.format(noDecimal ? Math.floor(num) : num) : "--";
};

const ONE_THOUSAND = 1000;
const ONE_LACS = 100000;
const ONE_CRORE = 10000000;

export const formatCurrencyWithLabels = (num, selectedLabel = null) => {
    let newNum = num;
    let label = null;
    // if (num > ONE_CRORE) {
    //     newNum = (newNum / ONE_CRORE) * 10;
    //     label = "cr";
    // } else
    if (!selectedLabel) {
        if (num > ONE_CRORE) {
            newNum = newNum / ONE_CRORE;
            label = "cr";
        }else if (num > ONE_LACS) {
            newNum = newNum / ONE_LACS;
            label = "lacs";
        } else if (num > ONE_THOUSAND) {
            newNum = newNum / ONE_THOUSAND;
            label = "k";
        } 
    }
    if (selectedLabel === "IN LACS") {
        newNum = newNum / ONE_LACS;
        label = "";
    } else if (selectedLabel === "IN CR") {
        newNum = newNum / ONE_CRORE;
        label = "";
    } else if (selectedLabel.includes("FULL NUMBER")) {
        return label
            ? `${formatCurrency(
                newNum,
                selectedLabel.includes("FULL NUMBER") ? true : false
            )} ${label}`
            : formatCurrency(
                newNum,
                selectedLabel.includes("FULL NUMBER") ? true : false
            );
    }
    return label
        ? `${formatCurrency(
            newNum,
            selectedLabel.includes("FULL NUMBER") ? true : false
        )} ${label}`
        : formatCurrency(
            newNum,
            selectedLabel.includes("FULL NUMBER") ? true : false
        );
};
